import { requestOTP } from 'data';

export default async function requestOTPUseCase(body, auth) {
    return requestOTP(body.payment_info, auth);
}
